import {
    GET_ALL_BYPASS_CUSTOMERS_BEGIN, GET_ALL_BYPASS_CUSTOMERS_SUCCESS, GET_ALL_BYPASS_CUSTOMERS_FAILURE,
    SET_BYPASS_CUSTOMERS_QUERY,
    GET_BYPASS_CUSTOMER_BEGIN, GET_BYPASS_CUSTOMER_SUCCESS, GET_BYPASS_CUSTOMER_FAILURE,
    POST_BYPASS_CUSTOMER_BEGIN, POST_BYPASS_CUSTOMER_SUCCESS, POST_BYPASS_CUSTOMER_FAILURE,
    DELETE_BYPASS_CUSTOMER_BEGIN, DELETE_BYPASS_CUSTOMER_SUCCESS, DELETE_BYPASS_CUSTOMER_FAILURE,
    CLEAN_BYPASS_CUSTOMER
} from '../constants/ActionTypes'

const initialState = {

    // Get All Bypass Customers
    pagination: { page: 0, pageSize: 10 },
    filter: [],
    sorting: [],
    rowCount: 0,

    allBypassCustomers: null,
    isLoadingAllBypassCustomers: false,
    hasErrorAllBypassCustomers: null,

    // Get Bypass Customer
    selectedBypassCustomer: null,
    isLoadingSelectedBypassCustomer: false,
    hasErrorSelectedBypassCustomer: null,

    // Post Bypass Customer
    createdBypassCustomer: null,
    isCreatingBypassCustomer: false,
    hasErrorCreatedBypassCustomer: null,

    // Delete Bypass Customer
    deletedBypassCustomer: null,
    isDeletingBypassCustomer: false,
    hasErrorDeletedBypassCustomer: null
}

/**
 * @description Reducer function for managing the state of the Bypass Customer.
 *
 * @author Maria Eduarda Franke
 * @param {Object} state - The current state of the Bypass Customer.
 * @param {Object} action - The action object that contains the type and payload.
 * @returns {Object} - The updated state of the Bypass Customer.
 */
const ReducerBypassCustomer = (state = initialState, action) => {
    switch (action.type) {

        // Get All Bypass Customers
        case GET_ALL_BYPASS_CUSTOMERS_BEGIN: {
            return {
                ...state,
                isLoadingAllBypassCustomers: true
            }
        }
        case GET_ALL_BYPASS_CUSTOMERS_SUCCESS: {
            return {
                ...state,
                rowCount: action.payload?.count,
                allBypassCustomers: action.payload?.rows,
                isLoadingAllBypassCustomers: false,
                hasErrorAllBypassCustomers: null
            }
        }
        case GET_ALL_BYPASS_CUSTOMERS_FAILURE: {
            return {
                ...state,
                allBypassCustomers: null,
                isLoadingAllBypassCustomers: false,
                hasErrorAllBypassCustomers: action.payload
            }
        }

        case SET_BYPASS_CUSTOMERS_QUERY: {
            return {
                ...state,
                filter: action.payload.filter ?? state.filter,
                pagination: action.payload.pagination ?? state.pagination,
                sorting: action.payload.sorting ?? state.sorting
            }
        }

        // Get Bypass Customer
        case GET_BYPASS_CUSTOMER_BEGIN: {
            return {
                ...state,
                isLoadingSelectedBypassCustomer: true
            }
        }
        case GET_BYPASS_CUSTOMER_SUCCESS: {
            return {
                ...state,
                selectedBypassCustomer: action.payload,
                isLoadingSelectedBypassCustomer: false,
                hasErrorSelectedBypassCustomer: null
            }
        }
        case GET_BYPASS_CUSTOMER_FAILURE: {
            return {
                ...state,
                selectedBypassCustomer: null,
                isLoadingSelectedBypassCustomer: false,
                hasErrorSelectedBypassCustomer: action.payload
            }
        }

        // Post Bypass Customer
        case POST_BYPASS_CUSTOMER_BEGIN: {
            return {
                ...state,
                isCreatingBypassCustomer: true,
                hasErrorCreatedBypassCustomer: null
            }
        }
        case POST_BYPASS_CUSTOMER_SUCCESS: {
            return {
                ...state,
                createdBypassCustomer: action.payload,
                isCreatingBypassCustomer: false,
                hasErrorCreatedBypassCustomer: null
            }
        }
        case POST_BYPASS_CUSTOMER_FAILURE: {
            return {
                ...state,
                createdBypassCustomer: null,
                isCreatingBypassCustomer: false,
                hasErrorCreatedBypassCustomer: action.payload
            }
        }

        // Delete Bypass Customer
        case DELETE_BYPASS_CUSTOMER_BEGIN: {
            return {
                ...state,
                isDeletingBypassCustomer: true
            }
        }
        case DELETE_BYPASS_CUSTOMER_SUCCESS: {
            return {
                ...state,
                deletedBypassCustomer: action.payload,
                isDeletingBypassCustomer: false,
                hasErrorDeletedBypassCustomer: null
            }
        }
        case DELETE_BYPASS_CUSTOMER_FAILURE: {
            return {
                ...state,
                deletedBypassCustomer: null,
                isDeletingBypassCustomer: false,
                hasErrorDeletedBypassCustomer: action.payload
            }
        }

        // Clean Bypass Customer
        case CLEAN_BYPASS_CUSTOMER: {
            return {
                ...state,
                createdBypassCustomer: null,
                isCreatingBypassCustomer: false,
                hasErrorCreatedBypassCustomer: null
            }
        }

        default: return state

    }
}

export default ReducerBypassCustomer